<template>
  <div class='news-wrapper'>
    <div class='left-list scroll' v-if="hasLeft"
      ref=parent>
      <List ref='newsList' :detail='model'
        v-model='selectArticle' :canload='false'
        @change='handleSelectChange' />
    </div>
    <div class='right-content scroll'
      ref='articlceWrap'>
      <iframe :src="iframeUrl"
        frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
import List from '@/pages/components/common_list';
import * as actions from '@/common/js/api'
export default {
  name: 'news',
  data() {
    return {
      selectArticle: {},
      title: '',
    }
  },
  provide() {
    return {
      selectArticle: () => (this.selectArticle),
      pageDetail: { ...this.model }
    }
  },
  props: ['model'],
  components: {
    List
  },
  computed: {
    hasLeft() {
      return this.model.treeid
    },
    iframeUrl() {
      const time = this.selectArticle.time || this.selectArticle.ctime
      const id = this.selectArticle.id || this.selectArticle.seq
      if (!time) return '';
      return `//news.10jqka.com.cn/field/fr/${this.$utils.thscSnsBaselibUtils.formatTime(time, '{YYYY}{MM}{DD}')}/${id}.shtml#code=${this.model.code}`
    }
  },
  beforeCreate: function () {
  },
  created: function () {
    // 迁移至common_list
    let {treeid, code, objid } = this.model
    // this.$client.getSeqByObjid(objid, code, treeid).then( res => {
    //     this.$refs.newsList.handleItemClick(res)
    // })
    this.$client.getStockName(this.model.industry).then(res => {
      this.title = res[this.model.industry].ZQMC + '研报';
    })
  },
  watch: {
    title: {
      handler(val) {
        this.takeThingsBack(this.title)
      }
    }
  },
  mounted: function () {
  },
  methods: {
    handleSelectChange(e) {
      this.selectArticle = e;
      this.$project.saveHistory(e);
    },
    filterId(obj) {
      return obj.id || obj.seq;
    },
    // 向外部边框传递信息
    takeThingsBack(title, collectInfo) {
      this.$dispatch('basic', 'LISTEN_CHILD', {
        method: 'freshBaseInfo',
        data: {
          componentName: this.model.componentName,
          collectInfo,
          title
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import '../common/page_common.less';
.right-content {
  height: 100% !important;
  margin-left: 10px !important;
  padding-right: 0px !important;
  display: flex;
  align-items: center;
  > iframe {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}
</style>